// Countdown.js 🕰
// Author: Willmer Barahona
// "We are drifting the great ocean of space and time;
// in that ocean, the events that shapes the future, are working themselves out"
// - Carl Sagan
// https://www.youtube.com/watch?v=p4HGaTovMMc

import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
// import moment from 'moment';

// Components
import CountdownModal from './CountdownModal';
import DataService from 'js/modules/dataservice';
import { createSessionExpiredCookie } from '../AccountsExpirationSessionCookie';

const inactivityThreshold = 120000; // 2 minutes
const internals = {
  inactivityTicker: null,
  sessionTicker: null,
  countdownTicker: null,
  inactivityThreshold,
  msCount: window._app.timeout,
  sessionMsCount: inactivityThreshold
};

class Countdown extends Component {
  state = {
    isModalOpen: false,
    minutes: 1,
    seconds: 59,
    disabled: false,
    msCount: internals.msCount,
    sessionMsCount: internals.sessionMsCount,
    title: 'YOUR SESSION IS ABOUT TO EXPIRE',
    copy: 'For your security and to protect your personal data, we automatically end your session when you haven\'t interacted with the site in the next:',
    btnCopy: 'I\'m still here',
    timestamp: new Date(),
    eventHorizon: new Date(new Date().getTime() + internals.msCount),
    cookieDeleted: false
  }

  componentDidMount() {
    console.log('countdown component did mount!!');
    this.prepareForeignEvents();
    this.prepareTimestamp();
  }

  //
  // Bind events
  // ******************************************************************************
  bindDocumentEvents = () => {
    document.addEventListener('onload', this.setInactivityTicker());
    // document.addEventListener('onmousedown', this.setInactivityTicker());
    document.addEventListener('onkeypress', this.setInactivityTicker());
    // document.addEventListener('ontouchstart', this.setInactivityTicker());
  }

  unbindDocumentEvents = () => {
    document.removeEventListener('onload', this.startCountdowns());
    // document.removeEventListener('onmousedown', this.startCountdowns());
    document.removeEventListener('onkeypress', this.startCountdowns());
    // document.removeEventListener('ontouchstart', this.startCountdowns());
  }

  //
  // Set timestamp when component is ready to fire
  // ******************************************************************************
  prepareTimestamp = () => {
    this.setState({ timestamp: new Date() });
  }

  //
  // Inactivity Ticker Functions
  // ******************************************************************************
  setInactivityTicker = () => {
    document.onload = this.restartInactivityTicker;
    // document.onmousemove = this.restartInactivityTicker;
    // document.onmousedown = this.restartInactivityTicker; // touchscreen presses
    // document.ontouchstart = this.restartInactivityTicker;
    // document.onclick = this.restartInactivityTicker;     // touchpad clicks
    // document.onscroll = this.restartInactivityTicker;    // scrolling with arrow keys
    document.onkeypress = this.restartInactivityTicker;
  }

  //
  // Inactivity Ticker
  // ******************************************************************************
  startInactivityTicker = () => {
    this.stopAllTickers();
    internals.inactivityTicker = setInterval(this.count, 1000);
  }

  stopInactivityTicker = () => {
    clearInterval(internals.inactivityTicker);
    this.setState({ msCount: internals.msCount });
  }

  restartInactivityTicker = () => {
    this.stopInactivityTicker();
    this.startInactivityTicker();
  }

  //
  // Inactivity Ticker
  // ******************************************************************************
  startSessionTicker = () => {
    this.stopAllTickers();
    internals.sessionTicker = setInterval(this.countSession, 1000);
  }

  stopSessionTicker = () => {
    if (!this.state.isModalOpen) {
      clearInterval(internals.sessionTicker);
      this.setState({ sessionMsCount: internals.sessionMsCount, minutes: 1, seconds: 59 });
    }
  }

  restartSessionTicker = () => {
    this.stopSessionTicker();
    this.startSessionTicker();
  }

  //
  // Prepare Foreign Events
  // ******************************************************************************
  prepareForeignEvents = () => {
    this.bindDocumentEvents();
    this.startInactivityTicker();
  }

  //
  // Actions
  // ******************************************************************************
  count = () => {
    if (!this.state.isModalOpen) {
      const { timestamp } = this.state;
      const now = new Date();
      const diffTime = now - timestamp;
      const diffMs = Math.floor(diffTime / 1000) * 1000;
      let count = this.state.msCount;

      count = internals.msCount - diffMs;

      this.stopSessionTicker();
      this.setState({ msCount: count }, () => {
        if (count <= internals.inactivityThreshold) {
          this.showModal();
          this.stopInactivityTicker();
          this.startSessionTicker();
        }
      });
    }
  }

  countSession = () => {
    const stateCopy = { ... this.state };
    const { sessionMsCount } = stateCopy;
    let { minutes, seconds, disabled, title, copy, btnCopy } = stateCopy;
    const { eventHorizon, cookieDeleted } = this.state;
    const now = new Date();
    const diffTime = eventHorizon - now;
    const diffMs = Math.floor(diffTime / 1000) * 1000;
    const diffSec = Math.floor(diffMs / 1000);

    // console.log(now, eventHorizon);

    let count = sessionMsCount;

    minutes = Math.floor(diffMs / 1000 / 60);
    seconds = (diffSec > 60) ? diffSec - 60 : diffSec;

    count = diffMs;

    if (count >= 1) {
      this.setState({ sessionMsCount: count, minutes, seconds });
    } else {
      // too late buddy, we dont want you to fuck up shit with this nice countdown, 1 second is too late for you
      disabled = true;
      title = 'YOUR SESSION HAS EXPIRED';
      copy = 'For your security and to protect your personal data, we automatically ended your session, due to inactivity with the site.';
      btnCopy = 'OK';

      if(!cookieDeleted) {
        createSessionExpiredCookie(1);
      }
      this.setState({ sessionMsCount: 0, minutes: 0, seconds: 0, disabled, title, copy, btnCopy, cookieDeleted: true }, () => {
        if (count === 0) {
          this.killAll();
          // this.unbindDocumentEvents();
        }
      });
    }
  }

  killAll = () => {
    // set here the inactive session.
    this.setState({ msCount: internals.msCount, sessionMsCount: internals.sessionMsCount }, () => {
      clearInterval(internals.countdownTicker);
      clearInterval(internals.inactivityTicker);
    });
  }

  stopAllTickers = () => {
    this.stopInactivityTicker();
    this.stopSessionTicker();
  }

  showModal = () => {
    this.setState({ isModalOpen: true });
  }

  closeModal = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen, timestamp: new Date() });
    if (!this.state.disabled) {
      this.stopAllTickers();
      this.startInactivityTicker();
      DataService.resetSession();
      console.warn('Front end session: reset counter, keep active');
    } else {
      console.warn('Front end session: counter ended, message was displayed and now we are sending the user to step 1');

      this.redirectToHome();
    }
  }

  redirectToHome = () => {
    console.warn('going to home redirected by countdown.js');
    window.location.href = '/';
  }

  render() {
    return (
      <Fragment>
        <CountdownModal
          isOpen={this.state.isModalOpen}
          onRequestClose={this.closeModal}
          minutes={this.state.minutes}
          seconds={this.state.seconds}
          disable={this.state.disabled}
          title={this.state.title}
          copy={this.state.copy}
          btnCopy={this.state.btnCopy}
        />
        <div style={{ display: 'none' }} className="countdown debug">countdown: {this.state.minutes}:{this.state.seconds}</div>
        <div style={{ display: 'none' }} className="countdown debug">msCount: {this.state.msCount}, sessionMsCount: {this.state.sessionMsCount}</div>
      </Fragment>
    );
  }
}

Countdown.propTypes = {
  sessionThreshold: propTypes.number,
  inactivityThreshold: propTypes.number,
  hasFlights: propTypes.bool
};

Countdown.defaultProps = {
  sessionThreshold: internals.sessionThreshold,
  inactivityThreshold: internals.inactivityThreshold,
  hasFlights: false
};

export default Countdown;



// WEBPACK FOOTER //
// ./js/components/global/countdown/Countdown.js